import MyPageContainer from './MyPageContainer';
import AccountPage from './Account/AccountPage';

export default MyPageContainer;
export { AccountPage };
